import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import LandingNavBarWeb from "./layouts/LandingNavBar.web";
import LandingNavBarMob from "./layouts/LandingNavBar.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";

const LandingNavbarComponent = withConditionalComponent(LandingNavBarWeb, LandingNavBarMob);

export default function LandingNavBar() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return <div className="flex items-center w-full justify-center">
    <LandingNavbarComponent trigger={isLargeScreen}/>
  </div>
}
